export const takeSetup = (take?: number | 'all' | null): number | 'all' => {
	return typeof take === 'number' && take > 0 ? take : take === 'all' ? 'all' : 1
}
